module.exports = __webpack_public_path__ + "static/media/Asset 40.a7f7d203.png";